import { Budget } from '@/components/pages/edit-campaign/form-elements/budget';
import { Dates } from '@/components/pages/edit-campaign/form-elements/dates';
import { TargetBudget } from '@/components/pages/edit-campaign/target-budget';

export function DefaultForm() {
  return (
    <>
      <Dates />
      <Budget />
      <TargetBudget />
    </>
  );
}
